<template>
    <div v-if="props.data" class="w-full bg-aboggray-100 rounded-lg p-4">
        <div class="w-full px-2 mb-6">
            <div class="float-right text-xl text-abogred-600 font-bold">{{ display.SlideID }}</div>
            <!-- <label class="block uppercase text-xs font-bold">
                {{ formDefinition[spec][sectionId].title }}
            </label> -->
            <h1 class="font-head text-xl font-bold">{{ display.CategoryDescription }}</h1>
        </div>
        <div class="flex flex-wrap">
            <div v-if="spec == 'URPS' || spec == 'REI' || spec == 'ONC'" class="w-full px-2 mb-6 lg:w-2/12">
                <label class="block uppercase text-xs font-bold mb-2">
                    {{ daysInHospitalLabel }}
                </label>
                <span class="px-4">{{ display.DaysInHospital }}</span>
            </div>

            <div class="w-full px-2 mb-6 lg:w-1/12">
                <label class="block uppercase text-xs font-bold mb-2 whitespace-nowrap"> Age </label>
                <span class="px-4">{{ display.PatientAge }}</span>
            </div>

            <div v-if="spec != 'URPS' && spec != 'ONC'" class="w-full px-2 mb-6 lg:w-1/12">
                <label class="block uppercase text-xs font-bold mb-2"> Gravida </label>
                <span class="px-4">{{ display.Gravida }}</span>
            </div>
            <div v-if="spec != 'ONC' && spec != 'URPS'" class="w-full px-2 mb-6 lg:w-1/12">
                <label class="block uppercase text-xs font-bold mb-2"> Para </label>
                <span class="px-4">{{ display.Para }}</span>
            </div>
            <div class="w-full px-2 mb-6 lg:w-1/6">
                <label class="block uppercase text-xs font-bold mb-2 whitespace-nowrap"> Collection TimeFrame </label>
                <span class="px-4 whitespace-nowrap">{{ casetimeframe }}</span>
            </div>
        </div>
        <div class="flex flex-wrap">
            <div class="w-full px-2 mb-6 lg:w-1/2">
                <label class="block uppercase text-xs font-bold mb-2 relative">
                    {{ formDefinition[spec][sectionId][1].Label }}
                </label>
                <p class="px-4 whitespace-pre-wrap overflow-auto">{{ display[formDefinition[spec][sectionId][1].Field] }}</p>
            </div>
            <div class="w-full px-2 mb-6 lg:w-1/2">
                <label class="block uppercase text-xs font-bold mb-2 relative">
                    {{ formDefinition[spec][sectionId][2].Label }}
                </label>
                <p class="px-4 whitespace-pre-wrap overflow-auto">{{ display[formDefinition[spec][sectionId][2].Field] }}</p>
            </div>
        </div>
        <div class="flex flex-wrap">
            <div class="w-full px-2 mb-6 lg:w-1/2">
                <label class="block uppercase text-xs font-bold mb-2 relative">
                    {{ formDefinition[spec][sectionId][3].Label }}
                </label>
                <p class="px-4 whitespace-pre-wrap overflow-auto">{{ display[formDefinition[spec][sectionId][3].Field] }}</p>
            </div>
            <div v-if="spec != 'URPS'" class="w-full px-2 mb-6 lg:w-1/2">
                <label class="block uppercase text-xs font-bold mb-2 relative">
                    {{ formDefinition[spec][sectionId][4].Label }}
                </label>
                <p class="px-4 whitespace-pre-wrap overflow-auto">{{ display[formDefinition[spec][sectionId][4].Field] }}</p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { reactive, computed } from "vue";
const props = defineProps(["data"]);
const display = computed(() => JSON.parse(props.data));
const spec = computed(() => display.value.Spec);
const sectionId = computed(() => display.value.C_Type);

const formDefinition = reactive({
    URPS: {
        1: {
            //Pelvic Organ Prolapse; Anorectal Disorders; Special Considerations  [Surgical - Prolapse & Recon]
            title: "Pelvic Organ Prolapse; Anorectal Disorders; Special Considerations",
            1: { Header: "Diagnosis", Field: "Text1", Label: "DIAGNOSIS (INCLUDE POP STAGE, IF APPLICABLE)", Limit: "200" },
            2: { Header: "Treatment", Field: "Text2", Label: "SURGICAL PROCEDURES / TREATMENT", Limit: "300" },
            3: { Header: "Status", Field: "Text3", Label: "COMPLICATIONS AND STATUS", Limit: "200" },
            4: { Header: "", Field: "", Label: "", Limit: "" },
            validate: { Hospital: false, DaysInHospital: true, Gravida: false, Para: false },
        },
        2: {
            //Urinary Incontinence: Frequency, Urgency, and Nocturia; UTI and Hematuria [Office]
            title: "Urinary Incontinence: Frequency, Urgency, and Nocturia; UTI and Hematuria",
            1: { Header: "Diagnosis", Field: "Text1", Label: "DIAGNOSIS (INCLUDE POP STAGE, IF APPLICABLE)", Limit: "200" },
            2: { Header: "Treatment", Field: "Text2", Label: "SURGICAL PROCEDURES / TREATMENT", Limit: "300" },
            3: { Header: "Status", Field: "Text3", Label: "COMPLICATIONS AND STATUS", Limit: "200" },
            4: { Header: "", Field: "", Label: "", Limit: "" },
            validate: { Hospital: false, DaysInHospital: true, Gravida: false, Para: false },
        },
        3: {
            //Neurogenic Lower Urinary Tract Dysfunction and Urinary Retention/Incomplete Emptying; Bladder and Myofacial Pelvic Pain; Urinary Tract Injury; Vaginal, Urethral and Periurethral Pain  [Surgical - Urinary & Fecal Incont]
            title: "Neurogenic Lower Urinary Tract Dysfunction and Urinary Retention/Incomplete Emptying; Bladder and Myofacial Pelvic Pain; Urinary Tract Injury; Vaginal, Urethral and Periurethral Pain",
            1: { Header: "Diagnosis", Field: "Text1", Label: "DIAGNOSIS (INCLUDE POP STAGE, IF APPLICABLE)", Limit: "200" },
            2: { Header: "Treatment", Field: "Text2", Label: "SURGICAL PROCEDURES / TREATMENT", Limit: "300" },
            3: { Header: "Status", Field: "Text3", Label: "COMPLICATIONS AND STATUS", Limit: "200" },
            4: { Header: "", Field: "", Label: "", Limit: "" },
            validate: { Hospital: false, DaysInHospital: true, Gravida: false, Para: false },
        },
    },
    ONC: {
        1: {
            //Ovary, Fallopian Tube, and Primary Peritoneal Cancers (including borderline tumors) [Ovarian, peritoneal, and fallopian tube cancer (include chemotherapy cases)]
            title: "Ovary, Fallopian Tube, and Primary Peritoneal Cancers (including borderline tumors)",
            1: { Header: "Problem / Diagnosis", Field: "Text1", Label: "Problem / diagnosis (include gestational age where applicable)", Limit: "200" },
            2: { Header: "Evaluation", Field: "Text2", Label: "Evaluation (labs, imaging, and other pertinent testing)", Limit: "200" },
            3: { Header: "Intervention", Field: "Text3", Label: "Intervention (treatment and/or procedure)", Limit: "300" },
            4: { Header: "Outcomes", Field: "Text4", Label: "Outcomes (including pathology with specimen weight when applicable, complications, current status)", Limit: "200" },
            validate: { Hospital: false, DaysInHospital: true, Gravida: false, Para: false },
        },
        2: {
            //Uterine Cancers (including Sarcoma) and Gestational Trophoblastic Diseases (including EIN, endometriosis, PAS/obstetric hemorrhage, leiomyoma) [Uterine malignancies: endometrial cancer, sarcoma, GTD, other]
            title: "Uterine Cancers (including Sarcoma) and Gestational Trophoblastic Diseases (including EIN, endometriosis, PAS/obstetric hemorrhage, leiomyoma)",
            1: { Header: "Problem / Diagnosis", Field: "Text1", Label: "Problem / diagnosis (include gestational age where applicable)", Limit: "200" },
            2: { Header: "Evaluation", Field: "Text2", Label: "Evaluation (labs, imaging, and other pertinent testing)", Limit: "200" },
            3: { Header: "Intervention", Field: "Text3", Label: "Intervention (treatment and/or procedure)", Limit: "300" },
            4: { Header: "Outcomes", Field: "Text4", Label: "Outcomes (including pathology with specimen weight when applicable, complications, current status)", Limit: "200" },
            validate: { Hospital: false, DaysInHospital: true, Gravida: false, Para: false },
        },
        3: {
            //Cervical, Vulvar, and Vaginal Cancers (including Dysplasia, Radiation, and Misc; e.g., intraoperative consultation) [Cervical, vulvar, and vaginal cancers and radiation therapy]
            title: "Cervical, Vulvar, and Vaginal Cancers (including Dysplasia, Radiation, and Misc; e.g., intraoperative consultation)",
            1: { Header: "Problem / Diagnosis", Field: "Text1", Label: "Problem / diagnosis (include gestational age where applicable)", Limit: "200" },
            2: { Header: "Evaluation", Field: "Text2", Label: "Evaluation (labs, imaging, and other pertinent testing)", Limit: "200" },
            3: { Header: "Intervention", Field: "Text3", Label: "Intervention (treatment and/or procedure)", Limit: "300" },
            4: { Header: "Outcomes", Field: "Text4", Label: "Outcomes (including pathology with specimen weight when applicable, complications, current status)", Limit: "200" },
            validate: { Hospital: false, DaysInHospital: true, Gravida: false, Para: false },
        },
    },
    REI: {
        1: {
            //Foundations of Reproductive Medicine  [Reproductive Endocrinology]
            title: "Foundations of Reproductive Medicine",
            1: { Header: "Problem / Diagnosis", Field: "Text1", Label: "Problem / diagnosis (include gestational age where applicable)", Limit: "200" },
            2: { Header: "Evaluation", Field: "Text2", Label: "Evaluation (labs, imaging, and other pertinent testing)", Limit: "200" },
            3: { Header: "Intervention", Field: "Text3", Label: "Intervention (treatment and/or procedure)", Limit: "300" },
            4: { Header: "Outcomes", Field: "Text4", Label: "Outcomes (including pathology with specimen weight when applicable, complications, current status)", Limit: "200" },
            validate: { Hospital: false, DaysInHospital: true, Gravida: true, Para: true },
        },
        2: {
            //Pregnancy and Genetics [Surgery]
            title: "Pregnancy and Genetics",
            1: { Header: "Problem / Diagnosis", Field: "Text1", Label: "Problem / diagnosis (include gestational age where applicable)", Limit: "200" },
            2: { Header: "Evaluation", Field: "Text2", Label: "Evaluation (labs, imaging, and other pertinent testing)", Limit: "200" },
            3: { Header: "Intervention", Field: "Text3", Label: "Intervention (treatment and/or procedure)", Limit: "300" },
            4: { Header: "Outcomes", Field: "Text4", Label: "Outcomes (including pathology with specimen weight when applicable, complications, current status)", Limit: "200" },
            validate: { Hospital: false, DaysInHospital: true, Gravida: true, Para: true },
        },
        3: {
            //Fertility and Infertility [Infertility]
            title: "Fertility and Infertility",
            1: { Header: "Problem / Diagnosis", Field: "Text1", Label: "Problem / diagnosis (include gestational age where applicable)", Limit: "200" },
            2: { Header: "Evaluation", Field: "Text2", Label: "Evaluation (labs, imaging, and other pertinent testing)", Limit: "200" },
            3: { Header: "Intervention", Field: "Text3", Label: "Intervention (treatment and/or procedure)", Limit: "300" },
            4: { Header: "Outcomes", Field: "Text4", Label: "Outcomes (including pathology with specimen weight when applicable, complications, current status)", Limit: "200" },
            validate: { Hospital: false, DaysInHospital: true, Gravida: true, Para: true },
        },
    },
    CFP: {
        1: { //Contraception [Contraception]
            title: "Contraception",
            1: {Header:'Problem / Diagnosis',Field:'Text1',Label:'Problem / diagnosis (include gestational age where applicable)', Limit:'300'},  
            2: {Header:'Evaluation', Field:'Text2', Label:'Evaluation (labs, imaging, and other pertinent testing)', Limit:'300'},
            3: {Header:'Intervention', Field:'Text3', Label:'Intervention (treatment and/or procedure)', Limit:'300' },
            4: {Header:'Outcomes', Field:'Text4', Label:'Outcomes (including pathology with specimen weight when applicable, complications, current status)', Limit:'300'},
            'validate':{Hospital:false, DaysInHospital:false, Gravida:true, Para:true}
        },
        2: { //Early Pregnancy Assessment/Pre-Abortion Evaluation/Medication Abortion [Early Pregnancy Evaluation and Management]
            title: "Early Pregnancy Assessment/Pre-Abortion Evaluation/Medication Abortion",
            1: {Header:'Problem / Diagnosis',Field:'Text1',Label:'Problem / diagnosis (include gestational age where applicable)', Limit:'300'},  
            2: {Header:'Evaluation', Field:'Text2', Label:'Evaluation (labs, imaging, and other pertinent testing)', Limit:'300'},
            3: {Header:'Intervention', Field:'Text3', Label:'Intervention (treatment and/or procedure)', Limit:'300'},                 
            4: {Header:'Outcomes', Field:'Text4', Label:'Outcomes (including pathology with specimen weight when applicable, complications, current status)', Limit:'300' },
            'validate':{Hospital:false, DaysInHospital:false, Gravida:true, Para:true}
        },
        3: { //Abortion Complications/Complex Abortion and Risk Stratification [Abortion/Pregnancy Termination]
            title: "Abortion Complications/Complex Abortion and Risk Stratification",
            1: {Header:'Problem / Diagnosis',Field:'Text1',Label:'Problem / diagnosis (include gestational age where applicable)', Limit:'300'},  
            2: {Header:'Evaluation', Field:'Text2', Label:'Evaluation (labs, imaging, and other pertinent testing)', Limit:'300'},
            3: {Header:'Intervention', Field:'Text3', Label:'Intervention (treatment and/or procedure)', Limit:'300' },
            4: {Header:'Outcomes', Field:'Text4', Label:'Outcomes (including pathology with specimen weight when applicable, complications, current status)', Limit:'300'},
            'validate':{Hospital:false, DaysInHospital:false, Gravida:true, Para:true} 
            },
    },
    NONE: {
        0: {},
    },
});

const daysInHospitalLabel = computed(() => {
    if ((spec.value == "OBGYN" && sectionId.value == 3)) { //|| (spec.value == "URPS" && sectionId.value == 2)
        return "Visits";
    } else {
        return "Hospital Nights or Visits";
    }
});

const casetimeframe = computed(() => {
    // the casetimeframe could be added the the case JSON instead
    if (display.value.Spec == "OBGYN") {
        switch (display.value.CaseTimeframe) {
            case 1:
                return "12 Months";
            case 2:
                return "18 Months";
            case 3:
                return "Senior Resident";
            case 4:
                return "Fellowship";
            default:
                return "";
        }
    } else if (display.value.Spec == "ONC") {
        if (display.value.CaseTimeframe == 18) {
            return "18 Months";
        } else {
            return display.value.CaseTimeframe == new Date().getFullYear() - 1 ? "12 Months" : "24 Months";
        }
    } else {
        switch (display.value.CaseTimeframe) {
            case 1:
                return "12 Months";
            case 2:
                return "24 Months";
            case 3:
                return "18 Months";
            default:
                return "";
        }
    }
});
</script>
